import React from 'react';
import ReactTooltip from 'react-tooltip';
import classNames from 'classnames';

// @ts-ignore TS(2322): Type 'null' is not assignable to type 'string'.
function Tooltip({ className = null, children = null, effect = 'solid', ...otherProps }) {
  const tooltipClass = classNames('ws-tooltip', className);

  return (
    // @ts-ignore TS(2769): No overload matches this call.
    <ReactTooltip className={tooltipClass} effect={effect} {...otherProps}>
      {children}
    </ReactTooltip>
  );
}

Tooltip.hide = () => ReactTooltip.hide();
Tooltip.rebuild = () => ReactTooltip.rebuild();

export default Tooltip;
